import { render } from "./localizedValue.vue?vue&type=template&id=bb1aa08a&ts=true"
import script from "./localizedValue.vue?vue&type=script&lang=ts"
export * from "./localizedValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__